import { render, staticRenderFns } from "./RoutinesTab.vue?vue&type=template&id=61addebf&scoped=true"
import script from "./RoutinesTab.vue?vue&type=script&lang=js"
export * from "./RoutinesTab.vue?vue&type=script&lang=js"
import style0 from "./RoutinesTab.vue?vue&type=style&index=0&id=61addebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61addebf",
  null
  
)

export default component.exports